import {
  data_get,
  data_merge,
  data_nullify,
  Identifiable,
  JsonableData,
  OptionalValue,
  PartialData,
  transform,
} from '../../../../../shared/utils/common';
import {to_numeric} from '../../../../../shared/utils/numbers';
import {JobMetadata, JobMetadataC} from './job-metadata';
import {RelateData} from './relate-data';

export class ProjectTaskCalendarEventMetadata implements Identifiable, JsonableData {
  readonly id = this._props.id;
  readonly name = this._props.name;
  readonly description = this._props.description;
  readonly milestone_name = data_nullify(
    data_get(this._props.milestone, 'name'),
  );
  readonly estimated_duration = to_numeric(this._props.estimated_duration);

  readonly is_deleted = false;
  readonly metadata_type = 'project_task';
  readonly metadata = data_merge(this._props, {
    updates: {
      milestone_name: data_nullify(
        data_get(this._props.milestone, 'name'),
      ),
    },
  });

  readonly job = transform(this._props.job, {
    transformer: (value) => new JobMetadataC(value),
  });

  readonly department = this._props.department;

  /// task calendar display props
  readonly job_text = data_get(this.job, 'job_number');
  readonly notes = this.description;
  readonly task_progress = 'awaiting_scheduling';
  readonly department_id = data_nullify(data_get(this.department, 'id'));
  readonly department_text = data_nullify(data_get(this.department, 'name'));
  readonly customer_id = data_nullify(data_get(this.job, 'customer_id'));
  readonly customer_text = data_nullify(data_get(this.job, 'customer_name'));
  /// end task calendar display props

  /// calendar event content parsing props
  readonly project_task = data_merge(this._props, {
    updates: {
      milestone_name: data_nullify(
        data_get(this._props.milestone, 'name'),
      ),
    },
  });
  readonly reschedulable = true;
  /// calendar event content parsing props

  /// work_location info
  readonly work_location_id = this._props.work_location_id;

  constructor(
    private readonly _props: ProjectTaskCalendarEventMetadataProps,
  ) {}

  copyWith(
    props: PartialData<ProjectTaskCalendarEventMetadataProps>,
  ): ProjectTaskCalendarEventMetadata {
    return new ProjectTaskCalendarEventMetadata({
      ...this._props,
      ...props,
    });
  }

  toJson = (): OptionalValue<Record<string, any>> => ({
    ... this._props,
    milestone_name: this.milestone_name,
    estimated_duration: this.estimated_duration,
    is_deleted: this.is_deleted,
    metadata_type: this.metadata_type,
    metadata: this.metadata,
    job: this.job,
    department: this.department,
    job_text: this.job_text,
    notes: this.notes,
    task_progress: this.task_progress,
    department_id: this.department_id,
    department_text: this.department_text,
    customer_id: this.customer_id,
    customer_text: this.customer_text,
    project_task: this.project_task,
    reschedulable: this.reschedulable,
    work_location_id: this.work_location_id,
  });
}

export type ProjectTaskCalendarEventMetadataProps = {
  id: string;
  name: string;
  description?: string;
  progress_percentage?: number;
  date_started?: string;
  date_ready?: string;
  date_completed?: string;
  estimated_duration?: number;
  budget_hourly_rate?: number;
  estimated_material_cost?: number;
  estimated_equipment_cost?: number;
  estimated_revenue?: number;
  wo_number?: string;
  actual_duration?: number;
  actual_hourly_rate?: number;
  actual_material_cost?: number;
  actual_equipment_cost?: number;
  actual_revenue?: number;

  milestone?: RelateData;
  department?: RelateData;
  job?: JobMetadata;

  work_location_id?: string;
};
